/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_update = /** @type {(inputs: {}) => string} */ () => {
	return `Actualizar`
};

const en_common_update = /** @type {(inputs: {}) => string} */ () => {
	return `Update`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_update = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_update(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_update", locale)
	if (locale === "es") return es_common_update(inputs)
	return en_common_update(inputs)
};
export { common_update as "common.update" }